"use strict";const t=e=>e.nodeName==="SLOT"?!1:e.offsetWidth<=0&&e.offsetHeight<=0||e.style&&e.style.visibility==="hidden";export default t;
//# sourceMappingURL=isElementHidden.js.map
